import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import {
  MenuOrderInMenuGroup,
  SearchMenuOrderInMenuGroup,
  SearchSubMenuGroup,
  SubMenuGroup,
} from './models/submenulist';

const subMenuGroupService = {
  getSubmenuGroupList(data: SearchSubMenuGroup): Promise<CommonResponse<Array<SubMenuGroup>>> {
    const url = `/submenu-groups`;
    return axiosClient.get(url, { params: data });
  },
  getSubmenuGroup(data: { subMenuGroupId: number; dataDate?: Date }): Promise<CommonResponse<SubMenuGroup>> {
    let url = `/get-submenu-group?id=` + data.subMenuGroupId;
    if (data.dataDate) {
      const dateDateFormat = moment(data.dataDate).format(DATE_HYPHEN_FORMAT);
      url += `&data_date=${dateDateFormat}`;
    }
    return axiosClient.get(url);
  },
  getSubMenuOrderInGroup(data: SearchMenuOrderInMenuGroup): Promise<CommonResponse<Array<MenuOrderInMenuGroup>>> {
    const url = `/submenu-order-groups`;
    return axiosClient.post(url, data);
  },
  patchSubMenuGroup(data: SubMenuGroup): Promise<CommonResponse<null>> {
    const url = `/submenu-group`;
    return axiosClient.patch(url, data);
  },
  patchSubMenuGroupOrder(data: Array<MenuOrderInMenuGroup>): Promise<CommonResponse<null>> {
    const url = `/submenu-group-order`;
    return axiosClient.patch(url, data);
  },
};

export default subMenuGroupService;
